import api from "./api";

export const getArticlesByAuthor = async (author) => {
  const articles = await api.get(`/articles/getAllArticlesByAuthor/${author}`);
  return articles.data;
};

export const getRecentArticles = async () => {
  const articles = await api.get(`/articles/getRecentArticles`);

  return articles.data;
};

export const getArticleById = async (id) => {
  const article = await api.get(`/articles/getArticleById/${id}`);
  return article.data;
};

export const addArticle = async (data) => {
  return api.post(`/articles/addArticle`, data);
};
